import { useEffect } from 'react';

interface ImageModalProps {
  isOpen: boolean;
  imageUrl: string;
  label: string;
  onClose: () => void;
}

export default function ImageModal({ isOpen, imageUrl, label, onClose }: ImageModalProps) {
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleKey);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleDownload = () => {
    const a = document.createElement('a');
    a.href = imageUrl;
    a.download = `${label}.jpg`;
    a.target = '_blank';
    a.click();
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center"
      style={{ backgroundColor: 'rgba(0,0,0,0.82)' }}
      onClick={onClose}
    >
      <div
        className="relative bg-white rounded-xl overflow-hidden max-w-4xl w-full mx-4"
        onClick={e => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-5 py-3" style={{ backgroundColor: '#1B4F72' }}>
          <span className="text-white font-semibold text-base">{label}</span>
          <div className="flex items-center gap-2">
            <button
              onClick={handleDownload}
              className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium text-white cursor-pointer whitespace-nowrap"
              style={{ backgroundColor: '#27ae60' }}
            >
              <i className="ri-download-2-line"></i>
              다운로드
            </button>
            <button
              onClick={onClose}
              className="w-8 h-8 flex items-center justify-center rounded-lg text-white hover:bg-white/20 cursor-pointer"
            >
              <i className="ri-close-line text-xl"></i>
            </button>
          </div>
        </div>
        {/* Image */}
        <div className="bg-black flex items-center justify-center" style={{ minHeight: 400 }}>
          {imageUrl ? (
            <img
              src={imageUrl}
              alt={label}
              className="max-w-full max-h-[70vh] object-contain"
            />
          ) : (
            <div className="flex flex-col items-center justify-center text-gray-400 py-20">
              <i className="ri-image-line text-5xl mb-2"></i>
              <span>이미지 없음</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
